import {nMonthsAgo} from "./utils/date";
import {DocumentGrouping, KeyFigureCode, Report, TimePeriodCode} from "./utils/type";

const {NODE_ENV} = process.env;

export const isDevelopment = NODE_ENV === "development";
export const API_URL = window.location.origin;

interface PerformanceCardTimePeriod {
  code: TimePeriodCode;
  type: "absolute" | "relative" | "both";
}

export const config = {
  general: {
    companyName: "Finansco",
    useProfitAndLoss: true,
  },
  overviewPage: {
    showAdvisor: true,
    showPieCharts: true,
    defaultTimePeriodCode: "GIVEN" as TimePeriodCode,
    timePeriodCodes: [
      "MONTHS-1",
      "MONTHS-3",
      "MONTHS-6",
      "CALYEAR-0",
      "YEARS-1",
      "YEARS-3",
      "GIVEN",
    ] as TimePeriodCode[],
    performanceCardTimePeriodCodes: [
      {code: "GIVEN", type: "relative"},
      {code: "GIVEN", type: "absolute"},
    ] as PerformanceCardTimePeriod[]
  },
  portfolioPage: {
    showKID: true,
    showCashBalance: false,
    showUnderlyingFee: false,
    showPieCharts: true,
    performanceCardTimePeriodCodes: [
      {code: "GIVEN", type: "relative"},
      {code: "GIVEN", type: "absolute"},
    ] as PerformanceCardTimePeriod[],
    keyFiguresToShow: [] as KeyFigureCode[],
    depositAndWithdrawal: {
      showDepositAndWithdrawal: false,
      depositTag: "Deposit-waiting,Group-finnets,NoDepositFee",
      withdrawalTag: "withdrawal-waiting",
    },
    defaultTimePeriodCode: "GIVEN" as TimePeriodCode,
    timePeriodCodes: [
      "MONTHS-1",
      "MONTHS-3",
      "MONTHS-6",
      "CALYEAR-0",
      "YEARS-1",
      "YEARS-3",
      "GIVEN",
    ] as TimePeriodCode[],
    portfolioList: {
      timePeriodCodes: [
        "MONTHS-1",
        "MONTHS-3",
        "MONTHS-6",
        "CALYEAR-0",
        "YEARS-1",
        "GIVEN",
      ] as TimePeriodCode[],
      portfolioStatusesToToggle: ["P", "C"],
    },
  },
  transactionsPage: {
    includeTradeOrders: false,
  },
  costsPage: {
    showCostsPage: false,
    timePeriods: [
      {code: "MONTHS-1" as TimePeriodCode, startDate: nMonthsAgo(1)},
      {code: "MONTHS-3" as TimePeriodCode, startDate: nMonthsAgo(3)},
      {code: "MONTHS-6" as TimePeriodCode, startDate: nMonthsAgo(6)},
      {
        code: "CALYEAR-0" as TimePeriodCode,
        startDate: new Date(new Date().getFullYear(), 0, 1),
      },
    ],
  },
  components: {
    securityDetails: {
      showFlags: true,
      defaultTimePeriodCode: "CALYEAR-0" as TimePeriodCode,
      timePeriodCodes: [
        "MONTHS-1",
        "MONTHS-3",
        "CALYEAR-0",
        "YEARS-1",
        "YEARS-3",
        "YEARS-5"
      ] as TimePeriodCode[],
    },
  },
  tradingPage: {
    showTradingPage: false,
    tradeableSecuritiesTags: [],
    fxMargin: 1.01,
    minInvestmentAmount: 1000
  },
  advisorPage: {
    showAdvisorPage: true,
    representativesToExclude: [10830, 9711, 8980, 7780, 8, 6, 127, 4293, 4451, 7436],
    showSavingsColumn: true,
    useAdvisorSplit: false,
    canUploadDocument: true,
    showDepositButton: true
  },
  savingsPage: {
    showSavingsPage: false,
    availableSavingsDates: [1, 10, 15, 20, 25],
    minSavingsPlanAmount: 500,
    minInvestmentAmountPerSavingItem: 100,
    maxNumberOfSecurities: 10,
  },
  securityDetailsPage: {
    showOngoingCosts: false,
    showManagementFee: false,
    showMinTradeAmount: false,
    showMorningstarRating: true,
    showSRRI: true,
    showSecurityDocuments: false,
    showFundDetails: true,
    showTopHoldings: true,
    showSectorAllocations: true,
    showGeographicAllocations: true,
    showSfdr: true,
    showFundDocumentsCard: false
  },
  documentsPage: {
    documentGrouping: [
      {
        pattern: /\b(skatt\d{4}|tax)\b/i,
        label: "Skattedokumenter"
      },
      {
        pattern: /\b(avtaler)\b/i,
        label: "Avtaledokumenter"
      }
    ] as DocumentGrouping[],
    reports: [
      {
        reportName: "DNB - Contract notes",
        label: "Sluttsedler",
        type: "pdf"
      },
      {
        reportName: "DNB - Bankkontoutdrag new",
        label: "Kontoutdrag",
        type: "pdf"
      },
      {
        reportName: "DNB - Kostnadsoversikt",
        label: "Kostnadsoversikt",
        type: "pdf"
      }
    ] as Report[],
  }
};
